<script>
    import {
        FormBoxContainer,
        FormBoxRow,
        FormBoxCell,
        Alert,
        Modal,
        BackDrop,
    } from '$lib/components/UI'
    import DocumentField from '$lib/components/UI/DocumentField.svelte'
    export let data = {}
    export let show = false
    const labels = {
        nombre_dp: 'Nombre (Datos del proveedor)',
        apellido_dp: 'Apellido',
        denominacion_dp: 'Denominacion Social',
        tipo_doc_dp: 'Tipo de documento',
        no_doc_dp: 'Nro de Documento',
        nombre_fantasia_dp: 'Nombre Fantasia',
        actividad_principal_dp: 'Actividad Principal',
        domicilio_dp: 'Domicilio',
        localidad_dp: 'Localidad',
        cp_dp: 'Codigo Postal (Datos del provedor)',
        tel_dp: 'Telefono',
        email_dp: 'Email',
        tipo_proveedor_ii: 'Tipo de proveedor',
        cuit_ii: 'cuit_iiCuit (Información Impostiva)',
        condicion_imp_iva_ii: 'Condicion de IVA',
        condicion_imp_ganancias_ii: 'Condicion de Ganancias',
        condicion_imp_ingresos_ii: 'Condicion de Ingresos Brutos',
        no_ingresos_brutos_ii: 'Nro de Ingresos Brutos',
        empleador_ii: 'Empleador',
        tiene_personal_lp: 'Tiene Personal',
        banco_ac: 'Banco',
        sucursal_ac: 'Sucursal',
        titular_ac: 'Titular de cuenta',
        cuit_ac: 'CUIT (Acreditacion de cuentas)',
        cbu_ac: 'CBU',
        domicilio_ac: 'Domicilio (Acreditacion de cuentas)',
        tel_ac: 'Telefono (Acreditacion de cuentas)',
        fax_ac: 'Fax',
        email_ac: 'Email (Acreditacion de cuentas)',
        presentado_ac: 'Presentado Por',
        tipo_doc_ac: 'Tipo de documento (Acreditacion de cuentas)',
        no_doc_ac: 'Nro de Documento (Acreditacion de cuentas)',
    }
</script>

<BackDrop visible={show} style="position:fixed">
    <Modal
        title="Solicitud de modificación"
        style="width: 75%; height: auto; max-height: 85%"
        scrolleable
        on:close={(_) => (show = false)}
        on:clickout={(_) => (show = false)}
    >
        <FormBoxContainer title="Campos">
            {#if data.fields}
                {#each data.fields.filter(({ key }) => key in labels) as { key, value, contrast } (key)}
                    <FormBoxRow>
                        <FormBoxCell
                            alt={`Antes "${contrast}"`}
                            label={labels[key]}
                            {value}
                        />
                    </FormBoxRow>
                {/each}
                {#if data.fields.filter(({ key }) => !(key in labels))}
                    <br />
                    <Alert type="info"
                        >Algunos campos no se pueden visualizar en esta sección</Alert
                    >
                {/if}
            {/if}
            {#if data.docs && data.docs instanceof Array && data.docs?.length > 0}
                <FormBoxContainer title="Documentos">
                    {#each data.docs as { title, link }}
                        <DocumentField
                            preview
                            {title}
                            on:preview={(_) =>
                                window.open(
                                    `${link}/preview`,
                                    title,
                                    'width=566,height=800,scrollbars=NO'
                                )}
                            on:download={(_) => {
                                window.open(link, '_blank')
                            }}
                        />
                    {/each}
                </FormBoxContainer>
            {/if}
        </FormBoxContainer>
    </Modal>
</BackDrop>
